/**
 * Poseedores API
 * Poseedores API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactoModel } from './contactoModel';


export interface AdheridoReferenceModel { 
    id?: number;
    razonSocial?: string;
    tipoDocumento?: AdheridoReferenceModel.TipoDocumentoEnum;
    codigoDocumento?: string;
    contactos?: Array<ContactoModel>;
}
export namespace AdheridoReferenceModel {
    export type TipoDocumentoEnum = 'NIF' | 'DNI' | 'NIE';
    export const TipoDocumentoEnum = {
        Nif: 'NIF' as TipoDocumentoEnum,
        Dni: 'DNI' as TipoDocumentoEnum,
        Nie: 'NIE' as TipoDocumentoEnum
    };
}


